var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"github-button",attrs:{"data-width":"256"}},[_c('button',{attrs:{"w-100":""},on:{"click":_vm.redirectToGitHub}},[_c('DynamicImage',{attrs:{"icon":'logo_github.svg',"height":20}}),_c('span',[_vm._v(_vm._s(_vm.buttonText))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }